import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Label } from "reactstrap";

import Flatpickr from "react-flatpickr";
import PositionTypeFilter from "pages/Payments/PositionTypeFilter";
import PaymentCategoryFilter from "pages/Payments/PaymentCategoryFilter";
import AgencyFilter from "pages/Payments/AgencyFilter";
import RegionFilter from "pages/Payments/RegionFilter";
import MDAFilter from "pages/Payments/MDAFilter";
import ThematicAreaFilter from "pages/Payments/ThematicAreaFilter";
import SectorFilter from "pages/Payments/SectorFilter";
import useQueryState from "Components/Hooks/UseQueryState";
import { defaultFilter, FilterType } from "./Filters";

const OffCanvasFilter = ({ show, onCloseClick, clearFilters }: any) => {
  const [filter, setFilter] = useQueryState<FilterType>(
    "filter",
    defaultFilter
  );
  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      id="offcanvasRight"
      toggle={onCloseClick}
    >
      <OffcanvasHeader className="bg-light" toggle={onCloseClick}>
        Payment Filters
      </OffcanvasHeader>
      <form
        action=""
        className="d-flex flex-column justify-content-end h-100"
        onSubmit={(e) => {
          e.preventDefault();
          onCloseClick();
        }}
      >
        <OffcanvasBody>
          <div className="mb-4">
            <Label
              htmlFor="region-field"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Region (FMS/FGS)
            </Label>
            <RegionFilter
              onChange={(value: any) => {
                setFilter({ ...filter, region: value });
              }}
              value={filter.region?.value ? filter.region : null}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              MDA
            </Label>
            <MDAFilter
              onChange={(value: any) => {
                setFilter({ ...filter, mda: value });
              }}
              value={filter.mda?.value ? filter.mda : null}
              regionId={filter.region?.value || ""}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Agency
            </Label>
            <AgencyFilter
              onChange={(value: any) => {
                setFilter({ ...filter, agency: value });
              }}
              value={filter.agency?.value ? filter.agency : null}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Date Range
            </Label>
            {/* @ts-ignore */}
            <Flatpickr
              className="form-control"
              placeholder="Select Date Range"
              options={{
                mode: "range",
                altFormat: "d M, Y",
                dateFormat: "d M, Y",
              }}
              onChange={(e) => {
                if (e[0] && e[1]) {
                  setFilter({
                    ...filter,
                    dateRange: {
                      fromDate: e[0],
                      toDate: e[1],
                    },
                  });
                }
              }}
              value={[
                filter?.dateRange?.fromDate || "",
                filter?.dateRange?.toDate || "",
              ]}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="country-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Payment Category
            </Label>

            <PaymentCategoryFilter
              onChange={(value: any) => {
                setFilter({ ...filter, paymentCategory: value });
              }}
              value={
                filter.paymentCategory?.value ? filter.paymentCategory : null
              }
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="country-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Position Type
            </Label>

            <PositionTypeFilter
              onChange={(value: any) => {
                setFilter({ ...filter, positionType: value });
              }}
              value={filter.positionType?.value ? filter.positionType : null}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="country-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Thematic Area
            </Label>

            <ThematicAreaFilter
              onChange={(value: any) => {
                setFilter({ ...filter, thematicArea: value });
              }}
              value={filter.thematicArea?.value ? filter.thematicArea : null}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="country-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Sector
            </Label>

            <SectorFilter
              onChange={(value: any) => {
                setFilter({ ...filter, sector: value });
              }}
              value={filter.sector?.value ? filter.sector : null}
            />
          </div>
        </OffcanvasBody>
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <button
            className="btn btn-light w-100"
            onClick={(e) => {
              e.preventDefault();
              clearFilters();
            }}
          >
            Clear Filter
          </button>
          <button
            type="submit"
            className="btn btn-success w-100"
            onClick={onCloseClick}
          >
            Submit
          </button>
        </div>
      </form>
    </Offcanvas>
  );
};

export default OffCanvasFilter;
